import React, { Fragment, useEffect, useState } from 'react';
import image from '../../assets/images/model/image-icon.svg';
import plusCricle from '../../assets/images/model/plus-addmedia.svg';
import ImageUploader from '../../Pages/Book/addMedia/ImageUploader';
import video from '../../assets/images/model/video_icon.svg';
import audio from '../../assets/images/model/audio-icon.svg';
import VideoUploadComponent from '../../Pages/Book/addMedia/VideoUploadComponent';
import AudioUploadComponent from '../../Pages/Book/addMedia/AudioUploadComponent';
import { editBlock } from '../../Store/api/create';
import { useDispatch } from 'react-redux';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import { bookActions } from '../../Store/entities/book';
import { useSelector } from 'react-redux';

export default function MediaComponent({ media, parent, parentId, index, chapterIndex, secInd, setBook, pIndex, mediaList = [], setMediaList = () => {} }) {
  const { book } = useSelector((state) => state.entities.book);
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const [mediaObj, setMediaObj] = useState(media);
  useEffect(() => {
    setMediaObj(media);
  }, [media]);
  const [uploadModal, setUploadModal] = useState('');

  const onSuccess = (fileUrl, alt, attribution) => {
    setMediaObj((old) => ({ ...old, url: fileUrl }));
    dispatch(
      editBlock({
        onSuccess: (res) => {
          const newChapters = JSON.parse(JSON.stringify(book.chapters));

          // Update the specific paragraph with new media
          newChapters[chapterIndex].sections[secInd].paragraphs[pIndex].media = res.data.data.media;

          // Update the state using setBook and dispatch
          setBook((old) => ({
            ...old,
            chapters: newChapters,
          }));

          dispatch(
            bookActions.setMyBook({
              ...book,
              chapters: newChapters,
            })
          );

          setMediaList((prev) => prev.map((medias) => (medias._id === media._id ? { ...medias, url: fileUrl } : medias)));
        },
        onError: (err) => {},
        body: {
          media: [{ url: fileUrl, alt, attribution, type: mediaObj.type }],
        },
        id: parentId,
        route: parent,
      })
    );
  };

  return (
    <div key={index}>
      {mediaObj.url ? (
        <div
          style={{
            position: 'relative',
            display: 'inline-grid',
            width: '100%',
            justifyContent: `${media.type !== 'video' ? 'center' : ''}`,
          }}
        >
          {media.type === 'image' ? (
            <img className='' style={{ borderRadius: '2px', maxHeight: '360px' }} src={mediaObj.url} alt={mediaObj.alt} />
          ) : media.type === 'audio' ? (
            <div className='drag_and_drop_box upload-boarder audio_padding audio_background' htmlFor='Drag-file'>
              <div className='deflat_content audio_file_parent' style={{ alignItems: 'flex-start' }}>
                <span className='audio_file'>Audio file</span>
                <span className='view_transcript'>View transcript</span>
              </div>
              <AudioPlayer
                style={{ width: '100%', background: 'var(--White, #fff)' }}
                autoPlay={false}
                src={mediaObj.url}
                onPlay={(e) => {}}
                customAdditionalControls={[]}
                customVolumeControls={[]}
                showJumpControls={false}
                customProgressBarSection={[
                  RHAP_UI.CURRENT_TIME,
                  <div className='slash_time' key='slash'>
                    /
                  </div>,
                  RHAP_UI.DURATION,
                  RHAP_UI.PROGRESS_BAR,
                ]}
              />
            </div>
          ) : (
            <iframe width='100%' height='385px' src={mediaObj.url} title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' referrerpolicy='strict-origin-when-cross-origin' allowfullscreen></iframe>
          )}
        </div>
      ) : (
        <Fragment>
          <UploadImageDrage item={mediaObj} index={index} setUploadModal={setUploadModal} user={user} />
        </Fragment>
      )}
      {uploadModal === 'image' && (
        <ImageUploader
          setUploadImageShow={() => {
            setUploadModal('');
          }}
          onSuccess={onSuccess}
        />
      )}
      {uploadModal === 'audio' && (
        <AudioUploadComponent
          setUploadAudioShow={() => {
            setUploadModal('');
          }}
          onSuccess={onSuccess}
        />
      )}
      {uploadModal === 'video' && (
        <VideoUploadComponent
          setUploadVideo={() => {
            setUploadModal('');
          }}
          setUploadVideoShow={() => {
            setUploadModal('');
          }}
          onSuccess={onSuccess}
        />
      )}
    </div>
  );
}
function UploadImageDrage({ item, setUploadModal, user }) {
  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-grid',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      {!item.url && (
        <div
          className='chapter_img_box'
          style={{
            width: '448px',
            height: `${item.type === 'audio' ? '67px' : '150px'}`,
          }}
          onClick={() => {
            if (user?.role !== 'STUDENT') setUploadModal(item.type);
          }}
        >
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <img src={item.type === 'image' ? image : item.type === 'video' ? video : audio} style={{ display: 'block' }} alt='add' />
            <img
              src={plusCricle}
              alt='plusCircle'
              style={{
                position: 'absolute',
                top: 0,
                left: 12,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
